export enum DataToolsApps {
  DATA_CLEANER = 'datacleaner',
  DUPLIKIT = 'duplikit',
  DUPLIKIT_CANDIDATE_REPORT = 'duplikit/candidate-report',
  DUPLIKIT_CONTACT_REPORT = 'duplikit/contact-report',
  DUPLIKIT_COMPANY_REPORT = 'duplikit/company-report',
  DUPLIKIT_OPTIONS = 'duplikit/duplikit-options',
  DUPLIKIT_DASHBOARD = 'duplikit/dashboard',
  DATARULES = 'datarules',
  DATARULES_SCHEDULING = 'datarulesScheduling',
  DATARULES_CREDENTIALLING = 'datarulesCredentialling',
  DATARULES_CHAINED_RULES = 'datarulesChainedRuleGroups',
  DATARULES_AI_ASSIST = 'datarulesAIAssist',
  DATATOOLS_SETTINGS = 'datatools-settings',
  HISTORY = 'history',
  HISTORY_DATARULES = 'history/datarules',
  HISTORY_DUPLIKIT = 'history/duplikit',
  ENRICHMENT_CREDIT_HISTORY = 'enrichment',
  HISTORY_ENRICHMENT_CREDITS = 'history/enrichment',
  META_DIFF = 'configuration',
  USERS = 'users',
  USER_MANAGEMENT = 'userManagement',
  DATATOOLS_LITE = 'datatoolsLite',
  ENRICHMENT_SETTINGS = 'enrichmentSettings',
  DATARULES_ENRICHMENT = 'datarulesEnrichment',
  DATARULES_BULLHORN_ONE_ENTITIES = 'datarulesBullhornOneEntities'
}

export enum DataToolsAppsTitles {
  DATA_CLEANER = 'DataCleaner',
  DUPLIKIT = 'DupliKit',
  DUPLIKIT_CANDIDATE_REPORT = 'Candidates Report',
  DUPLIKIT_CONTACT_REPORT = 'Contacts Report',
  DUPLIKIT_COMPANY_REPORT = 'Companies Report',
  DUPLIKIT_OPTIONS = 'Options',
  DUPLIKIT_DASHBOARD = 'Dashboard',
  DATARULES = 'DataRules',
  DATATOOLS_SETTINGS = 'Settings',
  HISTORY = 'History',
  USER_MANAGEMENT = 'Users',
  ENRICHMENT_SETTINGS = 'Enrichment',
  ENRICHMENT_CREDIT_HISTORY = 'Credit history'
}

export enum DataToolsAuth {
  COMPLETE = 'COMPLETE',
  IN_PROGRESS = 'IN_PROGRESS'
}
